export const JSONEducation = [
  {
    id: 1,
    name: "UNICV - Centro Universitário Cidade Verde",
    course: "Analise e Desenvolvimento de Sistemas",
    initialDate: "2021",
    endDate: "2024",
    desc: "A instituição é destaque como um importante centro de produção e difusão do conhecimento no Paraná e no Brasil, por buscar resultados sustentáveis por meio do ensino presencial e a distância.",
  }/* ,
  {
    id: 2,
    name: "B7Web",
    course: "React.JS",
    initialDate: "2021",
    endDate: "2021",
    desc: `React Completo, React Hooks, Context API, React Router, Redux, Styled components`,
  },
  {
    id: 3,
    name: "Origamid",
    course: "Html, Css, Javascript, Vue.js",
    initialDate: "2020",
    endDate: "2021",
    desc: `Html & Css, Javascript Completo ES6, Css Avançado Flexbox & Grid, Manipulação do DOM, Javascript Assincrono, Vue.js 2 Completo, Vuex & Vue Router, Axios & REST API`,
  },
  {
    id: 4,
    name: "Luiz Otávio Miranda",
    course: "Javascript do básico ao avançado",
    initialDate: "2021",
    endDate: "2021",
    desc: `JS Básico, Funcional e Orientado a Objetos, Princípios da programação orientada a objetos, Javascript Assincrono - Promisses, Fetch,
    Async/Await.
`,
  }, */
];

export const JSONExperience = [
  {
    id: 1,
    name: "Escriba Informática",
    course: "Programador de software",
    initialDate: "2023",
    endDate: "2025",
    desc: "Atuo no desenvolvimento e manuntenção de sistemas (SAAS)",
  },
  {
    id: 2,
    name: "Bytes Fritos",
    course: "Desenvolvedor Front-end - Freelance",
    initialDate: "2023",
    endDate: "PRESENT",
    desc: "Desenvolvimento e manutenção de sites e sistemas (SAAS) responsivos e otimizados",
  },
  {
    id: 3,
    name: "Guiador Digital",
    course: "Desenvolvedor Front-end",
    initialDate: "2021",
    endDate: "PRESENT",
    desc: "Atuo no desenvolvimento de aplicações performática e responsiva com as melhores tecnologias do mercado",
  },
  {
    id: 4,
    name: "Projeto Na Web",
    course: "Freelance",
    initialDate: "2021",
    endDate: "2022",
    desc: "Desenvolvimento de sites e aplicativos responsivos e otimizados",
  },
  /* {
    id: 5,
    name: "Ação Bike",
    course: "CEO",
    initialDate: "2017",
    endDate: "PRESENT",
    desc: "Desde a parte Administrativa e Financeira, até vendas e manutenção",
  },
  {
    id: 6,
    name: "Art Liberdade / Liber Glass",
    course: "Vidraceiro",
    initialDate: "2012",
    endDate: "2017",
    desc: "Produção de espelhos e vidros, Manutenção e instalação de box e sacadas, Pintura especializada em vidros",
  }, */
];
